import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../../../contexts/LocaleContext';
import { LINKS } from '../../../../config/links';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useLocale();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="eunoia-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t('footerEunoiaTitle')}</h3>
            <p>{t('footerEunoiaDescription')}</p>
            <div className="social-links">
              <a href={LINKS.apps.eunoia.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href={LINKS.apps.eunoia.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>{t('footerLegalTitle')}</h4>
            <ul>
              <li><Link to="/eunoia/privacy">{t('footerPrivacyPolicy')}</Link></li>
              <li><Link to="/eunoia/terms">{t('footerTermsOfService')}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} {t('footerEunoiaTitle')}. {t('footerAllRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;